import React from 'react';
import SlimFooter from './SlimFooter';
import FatFooter from './FatFooter';

const createReactClass = require('create-react-class');
const Footer = createReactClass({
  renderFooter(){
    const slimFooterPages = ['/signin','/signup','/signup-success','/checkout','/checkout-success', '/reset-password', '/change-password', '/otp-service'];
    
    if (slimFooterPages.indexOf(this.props.currentPath) > -1) {
      return <SlimFooter {...this.props}/>;
    }

    return <FatFooter {...this.props}/>;
  },
  render() {
    return this.renderFooter();
  },
});

export default Footer;


/** WEBPACK FOOTER **
 ** ./src/components/Layout/Footer/Footer.js
 **/